import {FC} from 'react';
import {shallowEqual} from 'react-redux';

import {useSelector} from '~/store/hooks';

import s from '../styles.module.scss';
import {FooterLogo} from '../../FooterLogo/FooterLogo';
import {FooterCopyright} from '../../FooterCopyright/FooterCopyright';

export const FooterMobile: FC = () => {
  const {instanceLabel} = useSelector(
    ({app}) => ({
      isSearchPage: app.data.page.isSearchPage,
      instanceLabel: app.data.instanceInfo.label,
    }),
    shallowEqual
  );

  return (
    <div className={s.footer}>
      <div className={s.footer__basement}>
        <FooterLogo />
        <FooterCopyright instanceLabel={instanceLabel} />
      </div>
    </div>
  );
};
